import { post , get, postFile } from '../axiosconfig'
import qs from 'qs'
export default {
  // 获取用户信息
  getUserInfo(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/user/info', params)
  },
  getUserInfoWebsite(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/user/info', params)
  },
  getViplist(params) {
    params = qs.stringify(params)
    return get('/zsc/web/vip/list', params)
  },
  // 编辑个人信息
  updateUserInfo(params){
    // params = qs.stringify(params)
    return post('/zsc/web/console/user/update', params)
  },
  // // 实名认证
  // realnameAuth(params){
  //   // params = qs.stringify(params)
  //   return post('/zsc/web/console/user/real_name_auth', params)
  // },
  studentAuth(params){
    return post('/zsc/web/console/user/student_auth', params)
  },
  // 上传文件实名认证
  realnameAuthFile(params,headers){
    return postFile('/zsc/web/console/user/real_name_auth', params, headers)
  },

  /******************** Alipay - 个人实名认证 ********************/
  // 个人实名 -认证
  person_real_name_auth(params) {
    return post('/zsc/web/console/user/person_real_name_auth', params)
  },
  // 个人实名 - 结果查询
  query_result(params) {
    return post('/zsc/web/console/user/person_real_name_auth/query_result', params)
  },
  // 个人实名 - 认证回调
  query_result_callback(params) {
    return post('/zsc/web/console/user/person_real_name_auth/callback', params)
  },

  /******************** 微信扫码绑定 ********************/
  // 微信扫码 -认证
  getWeChatCode(params) {
    params = qs.stringify(params)
    return get('/zsc/web/console/wechat/qrcode', params)
  },
  // 微信扫码 - 结果查询
  getWeChatResult(params) {
    params = qs.stringify(params)
    return get('/zsc/web/console/wechat/get-webhook-event', params)
  },

  /******************** Alipay - 法人授权人实名认证 ********************/
  // 法人授权人 - 认证
  company_person_certify(params) {
    return post('/zsc/web/console/user/certify', params)
  },
  // 法人授权人 - 认证结果查询
  company_person_certify_query_result(params) {
    return post('/zsc/web/console/user/certify/query_result', params)
  },
  // 法人授权人 - 企业认证
  company_real_name_auth(params) {
    return post('/zsc/web/console/user/company_real_name_auth', params)
  },
  // 法人授权人 - 企业认证结果查询
  company_person_set_certify_info(params) {
    return post('/zsc/web/console/user/invite/withdraw/account/set_certify_info', params)
  },

  /******************** 公司打款认证 ********************/
  // 公司打款 - 银行信息认证
  company_bank_real_name_auth(params) {
    return post('/zsc/web/console/user/company_bank_real_name_auth', params)
  },
  // 公司打款 - 打款金额验证
  company_amount_certify(params) {
    return post('/zsc/web/console/user/company_amount_certify', params)
  },

  //实名认证详情
  AuthDetails(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/user/real_name_auth/detail', params)
  },
  // 登录记录
  loginLog(params){
    params = qs.stringify(params)
    return get('/api/login/log', params)
  },

  // 新闻列表
  getNewslist(params) {
    params = qs.stringify(params)
    return get('/zsc/web/news/list', params)
  },
  // 新闻详情
  getNewsDetail(params) {
    params = qs.stringify(params)
    return get('/zsc/web/news/info', params)
  },

  // 获取路由
  getRouter(params){
    params = qs.stringify(params)
    return post('/api/user/getAuthInfo', params)
  },
  // 修改用户头像
  modifyUserAvatar(params,headers) {
    return postFile('/zsc/web/console/user/update', params, headers)
  },
  // 创建子账号
  createSubAccounts(params){
    return post('/zsc/web/console/user/sub_account/create', params)
  },
  // 子账号列表
  listOfSubAccounts(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/user/sub_account/list', params)
  },
  // 删除子账号
  deleteSubAccounts(params){
    return post('/zsc/web/console/user/sub_account/del', params)
  },
  // 修改子账号
  modifySubAccounts(params){
    return post('/zsc/web/console/user/sub_account/update', params)
  },
  //测试申请
  testapply(params){
    return post('/zsc/web/test_apply/create',params)
  },

  // 用户消息
  userMsgState(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/user/message/list', params)
  },
  // 用户消息状态更新
  userMsgStateChange(params){
    return post('/zsc/web/console/user/message/status/update',params)
  }

}



// WEBPACK FOOTER //
// ./src/api/public/index_api.js